import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';

import RSVPLink from 'components/RSVP/RSVPLink.tsx';
import RSVPFrame from 'components/RSVP/RSVPFrame.tsx';

import rsvpLogo from "gallery/rsvp-transparent.png";

 export default function RSVP() {
  return (
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
    }}>
      <Card sx={{ 
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffeedd",
          display: 'flex', 
          flexDirection: "column",
        }}>
        <CardHeader 
          title="" 
          titleTypographyProps = {{variant: "h4"}}
          />
        <CardMedia
          sx={{ 
            width: "100%",
            objectFit: "contain",
          }}
          component="img"
          image={rsvpLogo}
          title="Please RSVP"
        />
        <CardContent 
          sx={{
            width: "100%",
            px: 0,
          }}
        >
          <RSVPFrame />
          <Typography 
            variant="body2" 
            component="div"
            sx={{ 
              color: 'text.secondary',
              alignSelf:"center",
              textAlign:"center",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              pt: "1rem",
            }}
          >
            <RSVPLink linkText='If the RSVP is having trouble loading, please click HERE'/>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
